import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    ContainerDescriptions,
    ContentDescriptions,
    Text,
    TextBold,
} from "../styled";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import React from "react";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import {observer} from "mobx-react";
import {
    PaymentSubscriptionSimulateEntity
} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_simulate.entity";
import DividerDropDesk from "@dropDesk/presentation/components/divider";
import DescriptionGeneric
    from "@dropDesk/presentation/pages/subscription/ui/checkout/resume_value/days_to_first_payment";


const Body = observer((
    {
        newSubscription,
        labelFirstPayment,
        totalFirstPayment,
        quantityUsersNewSubs,
        simulate,
    }: {
        newSubscription: PaymentSubscriptionEntity
        labelFirstPayment?: string
        totalFirstPayment: number
        quantityUsersNewSubs: number
        simulate?: PaymentSubscriptionSimulateEntity
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (

        <ContainerDescriptions>
            <ContentDescriptions>
                <TextBold size={14} color={colors.hintInverse}>
                    Recorrência do pagamento:
                </TextBold>
                <Text size={14} color={colors.text}>mensal</Text>
            </ContentDescriptions>


            <ContentDescriptions>
                <TextBold size={14} color={colors.hintInverse}>
                    Quantidade de atendentes:
                </TextBold>
                <Text size={14} color={colors.text}>{quantityUsersNewSubs}</Text>
            </ContentDescriptions>

            <ContentDescriptions>
                <TextBold size={14} color={colors.hintInverse}>
                    Melhor dia para pagamento:
                </TextBold>
                <Text size={14} color={colors.text}>dia&nbsp;{newSubscription.dayDue}</Text>
            </ContentDescriptions>

            {simulate && <ContentDescriptions>
                <TextBold size={14} color={colors.hintInverse}>
                    Total mensal:
                </TextBold>
                <Text size={14} color={colors.text}>{formatCurrency(simulate.monthlyTotal ?? 0)}</Text>
            </ContentDescriptions>}

            {!!simulate?.changes?.length && <DividerDropDesk style={{marginTop: 10, marginBottom: 10}}/>}

            {simulate?.changes.map((change, index) => (
                <DescriptionGeneric
                    key={index}
                    label={change.description}
                    value={change.value}
                    isFormatCurrency={true}
                />
            ))}

            {simulate?.changes?.find(item => 'days' in item)?.days &&
                <DescriptionGeneric
                    label={'Dias faturado'}
                    value={simulate.changes.find(item => 'days' in item)!.days}/>
            }

            {!!simulate?.changes?.length && <DividerDropDesk style={{marginTop: 10, marginBottom: 10}}/>}

            <ContentDescriptions>
                <TextBold size={14} color={colors.hintInverse}>
                    {labelFirstPayment}
                </TextBold>
                <Text size={14} color={colors.text}>{formatCurrency(totalFirstPayment)}</Text>
            </ContentDescriptions>

        </ContainerDescriptions>
    );
});
export default Body;
